import { WithToggle } from 'components/shared/WithToggle/WithToggle';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { RenderPropChildren } from 'types/children';

import { ReminderTileLayout } from '../components';

export const ClosingTile: FC<{ onConfirm: () => void; onCancel: () => void }> = ({ onConfirm, onCancel }) => {
  const { formatMessage } = useIntl();
  return (
    <ReminderTileLayout
      image="delete_forever_outlined"
      titleKey={'dashboard.closing.title' as IntlKey}
      messageKey={'dashboard.closing.content' as IntlKey}
      className="text-danger"
    >
      <button className="btn btn-lg btn-discreet-secondary flex-grow-1 px-1 mx-1 flex-basis-100" onClick={onCancel}>
        {formatMessage({ id: 'dashboard.cancel' })}
      </button>
      <button className="btn btn-lg btn-outline-danger flex-grow-1 px-1  mx-1 flex-basis-100" onClick={onConfirm}>
        {formatMessage({ id: 'dashboard.closeAndDelete' })}
      </button>
    </ReminderTileLayout>
  );
};

ClosingTile.displayName = 'ClosingTile';

type WithClosingTileProps = Readonly<{
  onClose: () => void;
}>;

export const WithClosingTile: FC<WithClosingTileProps & RenderPropChildren<{ onClosing: () => void }>> = ({
  children,
  onClose,
}) => {
  return (
    <WithToggle isInitiallyOn={false}>
      {({ isOn, toggleOff, toggleOn }) => {
        if (isOn) {
          return <ClosingTile onConfirm={onClose} onCancel={toggleOff} />;
        }
        return <>{children({ onClosing: toggleOn })}</>;
      }}
    </WithToggle>
  );
};
